import Layout from './Layout'

export default {
  name: 'layout',
  configure: function(config) {
    config.addComponent('layout', Layout)
  }
}
